module.exports = __webpack_public_path__ + "assets/videos/green-xmas-poster-image.jpg?v=18d13d83";